import React from 'react';

import GridLogLicenze from './../containers/log/GridLogLicenze';


class LogLicenze extends React.Component {    

    render() {
        return (
            <React.Fragment>
                <h2 className={'content-block'}>Log Operazioni Licenze</h2>

                <GridLogLicenze />
            </React.Fragment>
        );
    }
};


export default LogLicenze;